const defaultStickies = [
    { id: 1, x: 32 * 1, y: 32 * 1, color: "yellow", text: "Dirty Laundry" },
    { id: 2, x: 32 * 3, y: 32 * 1, color: "yellow", text: "Clean Laundry" },
    { id: 3, x: 32 * 5, y: 32 * 1, color: "yellow", text: "Dirty Dishes" },
    { id: 4, x: 32 * 1, y: 32 * 3, color: "yellow", text: "Clean Dishes" },
    { id: 5, x: 32 * 3, y: 32 * 3, color: "yellow", text: "Table" },
    { id: 6, x: 32 * 5, y: 32 * 3, color: "yellow", text: "Trash" },
    { id: 7, x: 32 * 1, y: 32 * 5, color: "yellow", text: "Recycle" },
    { id: 8, x: 32 * 3, y: 32 * 5, color: "yellow", text: "Pets" },
    { id: 9, x: 32 * 5, y: 32 * 5, color: "yellow", text: "Trash + Recycle" },
    { id: 10, x: 32 * 1, y: 32 * 7, color: "yellow", text: "Sweep" },
    { id: 11, x: 32 * 3, y: 32 * 7, color: "yellow", text: "Vacuum Couch" },
    { id: 12, x: 32 * 5, y: 32 * 7, color: "yellow", text: "Counter" },
    { id: 13, x: 32 * 1, y: 32 * 9, color: "yellow", text: "Finn" },
    { id: 14, x: 32 * 3, y: 32 * 9, color: "yellow", text: "Mirrors" },
    { id: 15, x: 32 * 5, y: 32 * 9, color: "yellow", text: "Toilets" },
    { id: 16, x: 32 * 1, y: 32 * 11, color: "yellow", text: "Litter Box" },
    { id: 17, x: 32 * 3, y: 32 * 11, color: "yellow", text: "Living Room" },
    { id: 18, x: 32 * 5, y: 32 * 11, color: "yellow", text: "Bathroom Trash" },
    { id: 19, x: 32 * 8, y: 32 * 1, color: "teal", text: "5" },
    { id: 20, x: 32 * 8, y: 32 * 7, color: "teal", text: "10" },
    { id: 21, x: 32 * 8, y: 32 * 13, color: "teal", text: "15+$" },
    { id: 22, x: 32 * 17, y: 32 * 6, color: "lime", text: "Finn" },
    { id: 23, x: 32 * 17, y: 32 * 9, color: "lime", text: "Ian" },
    { id: 24, x: 32 * 17, y: 32 * 12, color: "lime", text: "Toby" },
    { id: 25, x: 32 * 17, y: 32 * 15, color: "lime", text: "Kairo" },
    { id: 26, x: 32 * 17, y: 32 * 18, color: "lime", text: "Clay" },
    { id: 27, x: 32 * 19, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 28, x: 32 * 21, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 29, x: 32 * 23, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 30, x: 32 * 25, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 31, x: 32 * 27, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 32, x: 32 * 29, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 33, x: 32 * 31, y: 32 * 21, color: "turquoise", text: "I went" },
    { id: 34, x: 32 * 33, y: 32 * 21, color: "turquoise", text: "I went" },
  ];

export default defaultStickies;